import { MEMBER_GQL_SCHEMA } from '@/requests/apollo/schema.ts'
import { gql, useMutation } from '@apollo/client'

export const useMutateProjectMembers = () => {
  const [updateRoleMutation] = useMutation(
    gql`mutation UpdateRole($projectId: ID!, $userId: ID!, $role: MemberRole!) {
      changeMemberRole(projectId: $projectId, userId: $userId, role: $role) {
        ${MEMBER_GQL_SCHEMA}
      }
    }`,
  )

  const [dropMemberMutation] = useMutation(
    gql`mutation DropMember($projectId: ID!, $userId: ID!) {
      dropMember(projectId: $projectId, userId: $userId) {
        ${MEMBER_GQL_SCHEMA}
      }
    }`,
  )

  return {
    updateRole: (projectId: string, member: Member, newRole: MemberRole) => {
      return updateRoleMutation({
        variables: {
          projectId: projectId,
          userId: member.id,
          role: newRole,
        },
        optimisticResponse: {
          changeMemberRole: {
            ...member,
            role: newRole,
          },
        },
      })
    },
    dropMember: (projectId: string, member: Member) => {
      return dropMemberMutation({
        variables: {
          projectId: projectId,
          userId: member.id,
        },
        optimisticResponse: {
          dropMember: {
            ...member,
            status: 'INACTIVE',
          },
        },
      })
    },
  }
}
